import React from 'react';
import AddressFormField from './AddressFormField';
import { MediaUpload } from '../../../components';
import classNames from 'classnames';
import BannerUpload from './BannerUpload';
import css from './SignupForm.module.css';

const UserTypeSpecificFields = ({
  form,
  intl,
  values,
  config,
  userType,
  isListingPage,
  listing = null,
}) => {
  const listingImageConfig = config.layout.listingImage;

  return (
    <div className={css.userTypeSpecificFields}>
      <AddressFormField
        form={form}
        name="location"
        label={intl.formatMessage({
          id: 'UserTypeSpecificFields.locationLabel',
        })}
        values={values}
      />
      <div className={classNames(css.formRow, css.fullWidth)}>
        <MediaUpload
          form={form}
          fieldName="logo"
          acceptedTypes={{
            'image/jpeg': [],
            'image/png': [],
          }}
          multiple={false}
          listingImageConfig={listingImageConfig}
          heading={intl.formatMessage({
            id: 'UserTypeSpecificFields.logoHeading',
          })}
          description={intl.formatMessage({
            id: 'UserTypeSpecificFields.logoDescription',
          })}
          userType={userType}
          values={values}
        />
      </div>

      {isListingPage && <BannerUpload listing={listing} form={form} />}
    </div>
  );
};

export default UserTypeSpecificFields;
